import { AloBaseLg, getDefaultAloBaseLg } from './AloBaseLg'

export interface AloMailSkinLg extends AloBaseLg {        
    msklSkin:string
}

export const getDefaultAloMailSkinLg = (lang=''):AloMailSkinLg => {
    return {  
        ...getDefaultAloBaseLg(lang),
        msklSkin:''
    }
}